import React from "react";
import Button from "@mui/material/Button";

interface OktaLoginPageProps {
  onLogin: () => void;
}

const OktaLoginPage: React.FC<OktaLoginPageProps> = ({ onLogin }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const myParam = urlParams.get("initialize");
  if (myParam === "true") {
    onLogin();
    return null;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Button
        variant="contained"
        color="primary"
        onClick={onLogin}
        size="large"
        style={{ minWidth: 220 }}
        data-testid="okta-login-btn"
      >
        Login with Okta SSO
      </Button>
    </div>
  );
};

export default OktaLoginPage;
